enum AuthErrorCodes {
  AlreadyInUse = 'auth/email-already-in-use',
  WeakPassword = 'auth/weak-password',
  InvalidEmail = 'auth/invalid-email',
  NetworkRequestFailed = 'auth/network-request-failed',
  WrongPassword = 'auth/wrong-password',
  AccountExistsWithDifferentCredentials = 'auth/account-exists-with-different-credential',
}

export const firebaseErrorCodeToTranslationMap = {
  [AuthErrorCodes.AlreadyInUse]: 'auth.errors.accountExists',
  [AuthErrorCodes.WeakPassword]: 'auth.errors.weakPassword',
  [AuthErrorCodes.InvalidEmail]: 'auth.errors.invalidEmail',
  [AuthErrorCodes.WrongPassword]: 'auth.errors.wrongPassword',
  [AuthErrorCodes.NetworkRequestFailed]: 'auth.errors.networkRequest',
  [AuthErrorCodes.AccountExistsWithDifferentCredentials]: 'auth.errors.accountExists',
};
